// frontend/source/portal/components/ArtworkPickerModal.js
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import api from "../../services/api";
import "./ArtworkPickerModal.css";

const ArtworkPickerModal = ({
  onSelect,
  onClose,
  categoryId,
  currentTagId,
  artistId,
}) => {
  const [artworks, setArtworks] = useState([]);
  const [selectedArtwork, setSelectedArtwork] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    loadArtworks();
  }, []);

  const loadArtworks = async () => {
    try {
      setLoading(true);
      let data;
      if (categoryId){
        data = await api.getArtworks(categoryId, 1, 0);
      }
      else {
        data = await api.getAllStudentArtworks( 1, 0);
      }
      // Filter out artworks already in this tag
      if (data && data.artworks){
        setArtworks(data.artworks);
      }     
      console.log("loaded artworks", artworks);
      setError(null);
    } catch (err) {
      setError("Failed to load artworks");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = () => {
    if (selectedArtwork) {
      onSelect(selectedArtwork._id);
    }
  };

  const filteredArtworks = artworks.filter((artwork) =>
    artwork.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const modalContent = (
    <div className="artwork-picker-overlay" onClick={onClose}>
      <div
        className="artwork-picker-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="artwork-picker-header">
          <h2 className="artwork-picker-title">Select Existing Artwork</h2>
          <button className="artwork-picker-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="artwork-picker-search">
          <input
            type="text"
            placeholder="Search artworks..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="artwork-picker-search-input"
          />
        </div>

        {error && <div className="artwork-picker-error">{error}</div>}

        <div className="artwork-picker-content">
          {loading ? (
            <div className="artwork-picker-loading">Loading artworks...</div>
          ) : filteredArtworks.length === 0 ? (
            <div className="artwork-picker-empty">
              {searchTerm
                ? "No artworks match your search"
                : "No artworks available"}
            </div>
          ) : (
            <div className="artwork-picker-grid">
              {filteredArtworks.map((artwork) => (
                <div
                  key={artwork._id}
                  className={`artwork-picker-item ${
                    selectedArtwork?._id === artwork._id ? "selected" : ""
                  }`}
                  onClick={() => setSelectedArtwork(artwork)}
                >
                  <img
                    src={artwork.image}
                    alt={artwork.title}
                    className="artwork-picker-thumbnail"
                  />
                  <div className="artwork-picker-info">
                    <h4 className="artwork-picker-item-title">
                      {artwork.title}
                    </h4>
                    {artwork.medium && (
                      <p className="artwork-picker-item-medium">
                        {artwork.medium}
                      </p>
                    )}
                    {artwork.year && (
                      <p className="artwork-picker-item-year">{artwork.year}</p>
                    )}
                  </div>
                  {selectedArtwork?._id === artwork._id && (
                    <div className="artwork-picker-check">✓</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="artwork-picker-footer">
          <button
            onClick={onClose}
            className="artwork-picker-btn secondary-btn"
          >
            Cancel
          </button>
          <button
            onClick={handleSelect}
            className="artwork-picker-btn primary-btn"
            disabled={!selectedArtwork}
          >
            Add to Tag
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default ArtworkPickerModal;
